(function () {
    'use strict';

    angular
    .module('szallodak-filter', ['daterangepicker']);
})();
